/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.docking

import kotlin.jvm.JvmField

/**
 * User: luc
 * Date: Jun 1, 2006
 * Time: 10:59:27 AM
 */
class DockingAnchor private constructor(private val myText: String) {
    override fun toString(): String {
        return myText
    }

    companion object {
        @JvmField public val TOP = DockingAnchor("top")
        @JvmField public val LEFT = DockingAnchor("left")
        @JvmField public val BOTTOM = DockingAnchor("bottom")
        @JvmField public val RIGHT = DockingAnchor("right")
    }
}